// import { deleteMethods } from '@/components/tools'
export default {
  className: 'postType',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '名称不可为空'
      ]
    }
  ],
  search: [
    'name'
  ],
  action: {
    delete: false
  }
}
